/**
 * Map browser IANA timezone → TradingView CustomTimezone.
 * Falls back to UTC offset tables when IANA id is not in TV's list.
 */

const zonesDST = {
  "-780": "Pacific/Fakaofo",
  "-765": "Pacific/Chatham",
  "-720": "Pacific/Auckland",
  "-600": "Australia/ACT",
  "-570": "Australia/Adelaide",
  "-540": "Asia/Tokyo",
  "-480": "Asia/Shanghai",
  "-420": "Asia/Bangkok",
  "-360": "Asia/Almaty",
  "-345": "Asia/Kathmandu",
  "-330": "Asia/Kolkata",
  "-240": "Asia/Dubai",
  "-270": "Asia/Tehran",
  "-180": "Europe/Moscow",
  "-120": "Europe/Paris",
  60: "Europe/London",
  180: "America/Sao_Paulo",
  240: "America/New_York",
  360: "America/El_Salvador",
  420: "America/Vancouver",
  600: "Pacific/Honolulu",
};

const zonesSTD = {
  "-825": "Pacific/Chatham",
  "-780": "Pacific/Auckland",
  "-660": "Australia/Brisbane",
  "-630": "Australia/Adelaide",
  "-540": "Asia/Tokyo",
  "-480": "Asia/Shanghai",
  "-420": "Asia/Bangkok",
  "-360": "Asia/Almaty",
  "-345": "Asia/Kathmandu",
  "-330": "Asia/Kolkata",
  "-240": "Asia/Dubai",
  "-210": "Asia/Tehran",
  "-180": "Europe/Moscow",
  "-120": "Africa/Cairo",
  "-60": "Europe/Paris",
  0: "Europe/London",
  120: "America/Argentina/Buenos_Aires",
  240: "America/Caracas",
  300: "America/Bogota",
  360: "America/El_Salvador",
  480: "America/Vancouver",
  600: "Pacific/Honolulu",
};

const TV_TIMEZONES = new Set([
  "Africa/Cairo",
  "Africa/Johannesburg",
  "Africa/Lagos",
  "America/Argentina/Buenos_Aires",
  "America/Bogota",
  "America/Caracas",
  "America/Chicago",
  "America/El_Salvador",
  "America/Juneau",
  "America/Lima",
  "America/Los_Angeles",
  "America/Mexico_City",
  "America/New_York",
  "America/Phoenix",
  "America/Santiago",
  "America/Sao_Paulo",
  "America/Toronto",
  "America/Vancouver",
  "Asia/Almaty",
  "Asia/Ashkhabad",
  "Asia/Bahrain",
  "Asia/Bangkok",
  "Asia/Chongqing",
  "Asia/Dubai",
  "Asia/Ho_Chi_Minh",
  "Asia/Hong_Kong",
  "Asia/Jakarta",
  "Asia/Jerusalem",
  "Asia/Kathmandu",
  "Asia/Kolkata",
  "Asia/Kuwait",
  "Asia/Muscat",
  "Asia/Qatar",
  "Asia/Riyadh",
  "Asia/Seoul",
  "Asia/Shanghai",
  "Asia/Singapore",
  "Asia/Taipei",
  "Asia/Tehran",
  "Asia/Tokyo",
  "Atlantic/Reykjavik",
  "Australia/ACT",
  "Australia/Adelaide",
  "Australia/Brisbane",
  "Australia/Perth",
  "Australia/Sydney",
  "Europe/Athens",
  "Europe/Belgrade",
  "Europe/Berlin",
  "Europe/Copenhagen",
  "Europe/Helsinki",
  "Europe/Istanbul",
  "Europe/London",
  "Europe/Luxembourg",
  "Europe/Madrid",
  "Europe/Moscow",
  "Europe/Oslo",
  "Europe/Paris",
  "Europe/Riga",
  "Europe/Rome",
  "Europe/Stockholm",
  "Europe/Tallinn",
  "Europe/Vilnius",
  "Europe/Warsaw",
  "Europe/Zurich",
  "Pacific/Auckland",
  "Pacific/Chatham",
  "Pacific/Fakaofo",
  "Pacific/Honolulu",
  "Pacific/Norfolk",
  "US/Mountain",
  "Etc/UTC",
]);

function stdTimezoneOffset(date) {
  const jan = new Date(date.getFullYear(), 0, 1).getTimezoneOffset();
  const jul = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
  return Math.max(jan, jul);
}

function getTradingChartTimezone(offset, period) {
  const zone = period === "DST" ? zonesDST[offset] : zonesSTD[offset];
  return zone || "Etc/UTC";
}

/** Initial chart display TZ from the browser (IANA), mapped to a TradingView timezone. */
export function getBrowserTradingChartTimezone() {
  try {
    const iana = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (iana && TV_TIMEZONES.has(iana)) {
      return iana;
    }
  } catch {
    // fall through to offset map
  }

  const now = new Date();
  const offset = now.getTimezoneOffset();
  const period = offset === stdTimezoneOffset(now) ? "STD" : "DST";
  return getTradingChartTimezone(offset, period);
}
